<p-table #dt [columns]="columns" [value]="items" sortField="area" sortMode="multiple"
  [tableStyle]="{ 'min-width': '50rem'}" dataKey="id" styleClass="p-datatable-striped p-datatable-gridlines"
  [loading]="isBusy" [filters]="filters" (onFilter)="handleFilter($event)" (onSort)="handleSort($event)"
  [scrollable]="true" scrollHeight="flex">
  <ng-template pTemplate="caption">
    <div class="flex">
      <p-button icon="pi pi-plus" label="Add" (click)="showAdd()" severity="success" />
      <p-button [ngStyle]="{'margin': '0 .5rem'}" [disabled]="!items||!items.length" icon="pi pi-download"
        label="Export" (click)="exportExcel()" />
      <p-button [ngStyle]="{'margin': '0 .5rem'}" icon="pi pi-refresh" [label]="getRefreshText()" (click)="refresh()" />
      <div style="margin:3rem;align-content:center;margin: 0 .5rem;">Total Records: {{this.totalRecords}}</div>
    </div>
  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th *ngIf="!col.hidden && !col.field" [title]="col.title||''"> {{col.label}}
        </th>
        <th *ngIf="!col.hidden&& col.field" [pSortableColumn]="col.field" [ngStyle]="{'min-width': col.width + 'px'}"
          [title]="col.title||''">
          {{col.label}} <p-sortIcon [field]="col.field" />
        </th>
      </ng-container>
    </tr>
    <tr>
      <ng-container *ngFor="let col of columns">
        <th *ngIf="!col.hidden">
          <p-columnFilter *ngIf="col.field && !col.options" [type]="col.filterType || 'text'" [field]="col.field"
            placeholder="All" [matchMode]="col.matchMode || 'startsWith'">
          </p-columnFilter>
          <p-columnFilter *ngIf="col.field && col.options" [field]="col.field" [matchMode]="col.matchMode"
            showMenu="false" [showClearButton]="false">
            <ng-template pTemplate="filter" let-value let-filter="filterCallback">
              <p-dropdown *ngIf="col.matchMode === 'equals'" [(ngModel)]="col.filterValue" [options]="col.options"
                (onChange)="filter($event.value)" placeholder="All" appendTo="body" optionLabel="label"
                optionValue="value" scrollHeight="400px">
              </p-dropdown>
              <p-multiSelect *ngIf="col.matchMode !== 'equals'" [(ngModel)]="col.filterValue" [options]="col.options"
                (onChange)="filter($event.value)" [filter]="false" [showHeader]="false" placeholder="All"
                appendTo="body" optionLabel="label" optionValue="value" scrollHeight="400px">
              </p-multiSelect>
            </ng-template>
          </p-columnFilter>
        </th>
      </ng-container>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-item let-columns="columns" let-rowIndex="rowIndex">
    <tr style="height:35px" [pSelectableRow]="item" [pSelectableRowIndex]="rowIndex">
      <ng-container *ngFor="let col of columns">
        <td *ngIf="!col.hidden && col.actions" [ngStyle]="{'max-width': col.width + 'px'}" [title]="item[col.field]">
          <ng-container *ngFor="let action of col.actions">
            <ng-container *ngIf="action.icon">
              <button [label]="action.label" [severity]="action.severity" *ngIf="!action.hidden" pButton type="button"
                icon="{{action.icon}}" (click)="action.action ? doAction(action.action, item) : null"
                [disabled]="action.disabled ? action.disabled(item) : false" [pTooltip]="action.tooltip"
                tooltipPosition="top" tooltipPositionStyle="absolute" tooltipStyleClass="tooltip"
                [style]="{ 'margin-right': '5px' }">
              </button>
            </ng-container>
          </ng-container>
        </td>

        <td *ngIf="!col.hidden && !col.actions && !col.editable" [ngStyle]="{'max-width': col.width + 'px'}" [title]="item[col.field]">
          <div *ngIf="!col.actions"
            [ngStyle]="{'overflow': 'hidden','white-space': 'nowrap','text-overflow': 'ellipsis', 'text-align': col.align || 'left'}">
            {{ col.getText ? getText(item, col) : item[col.field] }}</div>
        </td>

        <td *ngIf="!col.hidden && col.editable" [pEditableColumn]="item[col.field]" [pEditableColumnField]="col.field"
          [ngStyle]="{'max-width': col.width + 'px'}" [title]="item[col.field]||''">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input *ngIf="!col.options" autofocus="true"
                [type]="col.filterType == 'numeric' ? 'number' : col.filterType == 'date' ? 'date' : 'text'" pInputText
                [attr.maxlength]="col.maxLength" [(ngModel)]="item[col.field]" (change)="updateRecord(item)"
                [style]="{ 'width': '100%' }" />
              <p-dropdown #dd autofocus="true" selectOnFocus="true" (onFocus)="dropDownOnFocus(dd)" *ngIf="col.options"
                [style]="{ 'width': '100%' }" [(ngModel)]="item[col.field]" [options]="col.options" optionLabel="label"
                optionValue="value" (onChange)="updateRecord(item)" scrollHeight="400px" appendTo="body">
              </p-dropdown>
            </ng-template>
            <ng-template pTemplate="output">
              <div #o onfocus="click()" tabindex="0" class="p-component p-element p-input-text p-inputtext"
                [ngStyle]="{'overflow': 'hidden','white-space': 'nowrap','height': '30px', 'text-overflow': 'ellipsis', 'text-align': col.align || 'left'}">
                {{ col.getText ? getText(item, col) : item[col.field] }}</div>
            </ng-template>
          </p-cellEditor>
        </td>

      </ng-container>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage" let-columns>
    <tr>
      <td [attr.colspan]="columns.length">No records found.</td>
    </tr>
  </ng-template>
</p-table>


<p-dialog [(visible)]="showAddDialog" [style]="{ width: '450px' }" header="Add Application Area" [modal]="true"
  (keydown.enter)="addRecord()" styleClass="p-fluid">
  <ng-template pTemplate="content">
    <div class="field">
      <label for="name">Area</label>
      <input #newAreaInput type="text" [attr.maxlength]="20" pInputText id="area" [(ngModel)]="newRecord.area" />
    </div>
    <div class="field">
      <label for="description">Description</label>
      <input id="description" pInputText [attr.maxlength]="100" [(ngModel)]="newRecord.text" />
    </div>
    <div class="field">
      <label for="phase">Phase Sequence</label>
      <input #newAreaInput type="number" pInputText id="phase" [(ngModel)]="newRecord.phase" />
    </div>
    <div class="field">
      <label for="notes">Notes</label>
      <textarea pInputTextarea rows="2"[ngStyle]="{'resize': 'none'}" [(ngModel)]="newRecord.notes" [attr.maxlength]="3000">
      </textarea>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <p-button label="Save" icon="pi pi-check" [disabled]="!newRecord.area" (onClick)="addRecord()" />
  </ng-template>
</p-dialog>